/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { indexesAsk } from "../../funcs/indexesAsk.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.AskIndexRequest$inboundSchema,
};

export const tool$indexesAsk: ToolDefinition<typeof args> = {
  name: "indexes-ask",
  description: `Ask a question to an index

Ask a natural language question and get a synthesized answer from documents in the index`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await indexesAsk(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
